import { CircularProgress } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { FormattedMessage } from 'react-intl';

const LoadingSnackbar = ({ stateValue }: { stateValue: boolean }) => {
  return (
    <Snackbar
      open={stateValue}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{
        backgroundColor: 'transparent',
        marginTop: '-10px',
      }}
    >
      <MuiAlert
        elevation={6}
        variant='filled'
        icon={
          <CircularProgress
            color='inherit'
            size={18}
            sx={{ alignSelf: 'center' }}
          />
        }
        sx={{
          background: 'linear-gradient(270deg, #03B4C2 0%, #1E4EE5 100%)',
          color: 'white',
          borderRadius: '10px',
          textAlign: 'center',
          fontSize: '12px',
        }}
      >
        <FormattedMessage defaultMessage='Loading' />...
      </MuiAlert>
    </Snackbar>
  );
};

export default LoadingSnackbar;
